const BLOCKED_DOMAINS = ["nullsto", "imail"];
const ALLOWED_TOP_LEVELS = ["edu", "ac", "org"];

/**
 * Validates if email addrtess has an allowed top-level domain and is not blocked.
 * This is used to validate email addresses for EDU plan.
 *
 * @param {string} email
 * @returns {string|undefined} - Returns an error message if the domain is blocked or not allowed, otherwise undefined.
 */
module.exports = function validateEduDomains(email) {
    const domain = new URL("https://" + email.split("@").pop());
    const [topLevel, foreignTopLevel, name] = domain.hostname.split(".").reverse();

    if (topLevel === "ai" && foreignTopLevel === "beautiful") {
        // Allow beautiful.ai emails for testing
        return;
    }

    if (BLOCKED_DOMAINS.includes(name) || BLOCKED_DOMAINS.includes(foreignTopLevel)) {
        return "Email domain name is blocked.";
    }

    if (!ALLOWED_TOP_LEVELS.includes(topLevel) && !ALLOWED_TOP_LEVELS.includes(foreignTopLevel)) {
        return "Email must have an edu/ac/org top-level domain.";
    }
};
